import { useEffect, useState } from "react";
import { MdCheckCircleOutline } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { getAllProviderData_, getPendingIDCheck } from "../../utils/apis/func";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";
import { FaSearch } from "react-icons/fa";
import EmptyState from "../../components/helpers/emptyState";
import Scrollbar from "../../components/scrollbar";
import Loader from "../../components/Loader";
import NinReuseNotice from "../../components/NinReuseNotice";
import { addisLoading } from "../../utils/redux/mainSlice";
import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const PendingIDCheck = () => {
  const [businesss, setBusinesss] = useState([]);
  const [business, setBusiness] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useAppDispatch();

  const itemsPerPage = 25;
  const totalItems = (businesss as any)?.totalRecords;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = business?.slice(0, itemsPerPage);

  const filteredFreelancers =
    searchTerm.length > 0
      ? itemsToShow.filter(
          (item: any) =>
            item?.firstName
              ?.toLowerCase()
              ?.includes(searchTerm.toLowerCase()) ||
            item?.lastName?.toLowerCase()?.includes(searchTerm.toLowerCase())
        )
      : itemsToShow;

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  // const dispatch = useAppDispatch();
  const [loading, setloading] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [openDeclineModal, setOpenDeclineModal] = useState(false);

  useEffect(() => {
    const fetchPendingBrands = async () => {
      try {
        dispatch(addisLoading(true));
        const res = await getPendingIDCheck();
        const brands = (res as any)?.data?.data?.results;
        setBusinesss((res as any)?.data?.data);
        setBusiness(brands || []);
      } catch (err) {
        console.log(err);
      } finally {
        dispatch(addisLoading(false));
      }
    };
    fetchPendingBrands();
  }, []);

const handleNextPageClickk = async () => {
  dispatch(addisLoading(true));
  const AuthToken = await localStorage.getItem("AuthToken");
  const nextPage = currentPage + 1;

  try {
    const res = await axios({
      method: "get",
      url: `https://api.pureworker.com/api/admin/pending-verifications?page=${nextPage}&limit=25`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });

    const newBusiness = res?.data?.data?.results;
    setBusiness(newBusiness); // Replaces with new page's data
    setCurrentPage(nextPage);
  } catch (error) {
    console.log(error);
  }
  dispatch(addisLoading(false));
};

const handlePrevPageClickk = async () => {
  dispatch(addisLoading(true));
  const AuthToken = await localStorage.getItem("AuthToken");
  const prevPage = currentPage - 1;

  try {
    const res = await axios({
      method: "get",
      url: `https://api.pureworker.com/api/admin/pending-verifications?page=${prevPage}&limit=25`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
    });

    const newBusiness = res?.data?.data?.results;
    setBusiness(newBusiness); // Replaces with new page's data
    setCurrentPage(prevPage);
  } catch (error) {
    console.log(error);
  }
  dispatch(addisLoading(false));
};


  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const handleOpen = () => {
    setOpen(!open);
  };

  const checkImg = (selectedItem as any)?.user?.verificationImage;

  const handleApprove = async () => {
    console.log("approved ");
  };

const handleDecline = (item: any) => {
    setSelectedItem(item);
    setOpenDeclineModal(true);
  };

const submitDecline = async () => {
  if (!declineReason.trim()) {
    toast.error("Please provide a reason for the decline.");
    return;
  }

  console.log("Decline reason:", declineReason);

  dispatch(addisLoading(true));

  try {
    const AuthToken = await localStorage.getItem("AuthToken");
    const res = await axios({
      method: "post",
      url: `https://api.pureworker.com/api/admin/approve-verifications/${selectedItem?._id}`,
      headers: {
        Authorization: `Bearer ${AuthToken}`,
      },
      data: {
        status: "rejected",
        reason: declineReason.trim(),
      },
    });

    if (res.status === 200) {
      toast.success("Decline successfully submitted.");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      toast.error("Failed to decline the request.");
    }
  } catch (error) {
    console.error("Error submitting decline:", error);
    toast.error("An error occurred while declining.");
  } finally {
    dispatch(addisLoading(false));
    setOpenDeclineModal(false);
  }
};

  console.log("SELECTED ITEM", selectedItem);
  return (
    <>
      <div className="mb-4">
        <div className="ml-10 flex items-center sm:flex ">
          <FaSearch className="text-[#88087B]" />
          <input
            type="text"
            className=" rounded-full ml-4 px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-[#8E8E93] focus:outline-none"
            placeholder="Search Freelancers"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      {business?.length < 1 && (
        <EmptyState
          title={"No Verification Requests"}
          text={"Your Verification Request would be displayed here"}
        />
      )}
      {business?.length > 0 && (
        <div className="">
          <section className="">
            <div className="overflow-x-auto rounded-t-lg">
              <table className="w-full">
                <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-md font-medium">
                  <tr>
                    <th className="py-3 px-4">Business Name</th>
                    <th className="py-3 px-4">Phone Number</th>
                    <th className="py-3 px-4">Email</th>
                    <th className="py-3 px-4">Type</th>
                    <th className="py-3 px-4">Numbre</th>

                    {/* <th className="py-3 px-4">ID Type</th>
                <th className="py-3 px-4">ID Number</th>
                <th className="py-3 px-4">Scheduled Time</th> */}
                    <th className="py-3 px-4"></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFreelancers.map((item: any) => (
                    <tr
                      key={item.id}
                      onClick={async () => {
                        // navigate(`/verification/${item?.id || item?._id}`);
                        // dispatch(addviewProviderInReview(item));
                        // await handleGet(item?.id || item?._id);
                        // handleOpen();
                        // setSelectedItem(item);
                      }}
                      className="hover:bg-[#87878d] transition duration-300 font-roboto text-xs font-medium leading-normal text-center"
                    >
                      <td className="py-2 px-4">
                        {item?.user?.firstName
                          ? `${item?.user?.firstName} ${item?.user?.lastName}`
                          : item?.user?.businessName}
                      </td>
                      <td className="py-2 px-4">{item?.user?.phoneNumber}</td>
                      <td className="py-2 px-4">{item?.user?.email}</td>
                      <td className="py-2 px-4">{item?.type}</td>
                      <td className="py-2 px-4">{item?.number}</td>

                      <td className="px-6 py-4 flex gap-4 items-center ">
                        <button
                          className="font-medium text-white bg-[#50b555] px-2 rounded-lg py-2 hover:underline"
                          onClick={() => {
                            handleOpen();
                            setSelectedItem(item);
                          }}
                        >
                          View
                        </button>

                        <button className="font-medium text-white bg-[#FF0000] px-2 rounded-lg py-2 hover:underline"
                        onClick={() => handleDecline(item)}>
                          Decline
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Scrollbar
              currentPage={(businesss as any)?.currentPage}
              totalPages={Math.ceil(totalItems / itemsPerPage)}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
              onPrevPageClick={handlePrevPageClickk}
              onNextPageClick={handleNextPageClickk}
            />
          </section>
        </div>
      )}
      {loading && <Loader />}

      <Dialog open={openDeclineModal} handler={() => setOpenDeclineModal(false)}>
        <DialogHeader>Decline Verification Request</DialogHeader>
        <DialogBody>
          <div>
            <label htmlFor="declineReason" className="block mb-2">
              Reason for Decline
            </label>
            <textarea
              id="declineReason"
              rows={4}
              value={declineReason}
              onChange={(e) => setDeclineReason(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Enter reason here..."
            ></textarea>
            <div className="mt-4">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-lg mr-2"
                onClick={submitDecline}
              >
                Submit
              </button>
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded-lg"
                onClick={() => setOpenDeclineModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </DialogBody>
     
        </Dialog>

      <ToastContainer />
 
      <Dialog open={open} handler={handleOpen}>
        <DialogHeader>Business Details</DialogHeader>
        <DialogBody className="overflow-auto">
          <div className="relative p-4 w-full max-h-full flex flex-col overfl">
            <div className="p-4 md:p-5 mx-auto">
              <div className="">
                {(selectedItem as any)?.user ? (
                  <img
                    alt="jame"
                    className="max-h-[250px]"
                    src={`${(selectedItem as any)?.user?.verificationImage}`}
                  />
                ) : (
                  <p>No image available</p>
                )}
              </div>
              <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <tbody>
                  <tr>
                    <td className="py-2 px-4 font-semibold">Name</td>
                    <td className="py-2 px-4">
                      {(selectedItem as any)?.user.firstName
                        ? `${(selectedItem as any)?.user?.firstName} ${
                            (selectedItem as any)?.user?.lastName
                          }`
                        : (selectedItem as any)?.user?.businessName}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4 font-semibold">Phone Number</td>
                    <td className="py-2 px-4">
                      {(selectedItem as any)?.user?.phoneNumber}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4 font-semibold">Email</td>
                    <td className="py-2 px-4">
                      {(selectedItem as any)?.user?.email}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4 font-semibold">Type</td>
                    <td className="py-2 px-4">{(selectedItem as any)?.type}</td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4 font-semibold">Number</td>
                    <td className="py-2 px-4">
                      {(selectedItem as any)?.number}
                    </td>
                  </tr>
                </tbody>
              </table>

              <NinReuseNotice evidence={(selectedItem as any)?.ninReuse} />
              <div className="mt-6 flex justify-center">
                <Link
                  to={`/id-check/${
                    (selectedItem as any)?._id || ""
                  }/verify-nin`}
                  type="button"
                  className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
                  // onClick={handleApprove}
                >
                  Verify Detail
                </Link>
                <button
                  type="button"
                  className="text-gray-500 ml-4 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  onClick={() => setOpen(false)}
                >
                  No, cancel
                </button>
                {/* Uncomment below if loading spinner is needed */}
                {/* {isLoading && (
                <>
                  <Dots size={40} color="var(--admin-accent)" />
                </>
              )} */}
              </div>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default PendingIDCheck;
